import { ResourceOptions } from 'react-admin';
import { FaClipboardList } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxTaskClaims;
export const icon = FaClipboardList;
export const options: ResourceOptions = {
  label: 'module.blindBox.taskClaims',
};

